export default "__VITE_ASSET__fbbf0f0e__"